// Format des dates (décision 29) : « 21 oct. », « 12 au 19 oct. », année seulement
// si ce n'est pas l'année en cours. Les dates du serveur sont en secondes.

const MONTHS = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.']

export const DAY = 24 * 60 * 60

export function nowSeconds()
{
	return Math.round(Date.now() / 1000)
}

function toDate(seconds)
{
	return new Date(seconds * 1000)
}

function dayLabel(date)
{
	const day = date.getDate()
	return day === 1 ? '1er' : String(day)
}

export function formatShortDate(seconds, now = nowSeconds())
{
	const date = toDate(seconds)
	let label = dayLabel(date) + ' ' + MONTHS[date.getMonth()]
	if (date.getFullYear() !== toDate(now).getFullYear())
		label += ' ' + date.getFullYear()
	return label
}

export function formatRange(start, end, now = nowSeconds())
{
	const a = toDate(start)
	const b = toDate(end)
	const currentYear = toDate(now).getFullYear()
	if (a.getFullYear() === b.getFullYear())
	{
		const yearSuffix = a.getFullYear() !== currentYear ? ' ' + a.getFullYear() : ''
		if (a.getMonth() === b.getMonth())
			return dayLabel(a) + ' au ' + dayLabel(b) + ' ' + MONTHS[b.getMonth()] + yearSuffix
		return dayLabel(a) + ' ' + MONTHS[a.getMonth()] + ' au ' + dayLabel(b) + ' ' + MONTHS[b.getMonth()] + yearSuffix
	}
	return formatShortDate(start, now) + ' au ' + formatShortDate(end, now)
}

// « 21 oct. à 10:42 » (commentaires et photos, décision 28)
export function formatDateTime(seconds, now = nowSeconds())
{
	const date = toDate(seconds)
	const hours = String(date.getHours()).padStart(2, '0')
	const minutes = String(date.getMinutes()).padStart(2, '0')
	return formatShortDate(seconds, now) + ' à ' + hours + ':' + minutes
}
